/* eslint-disable */
export default (APP_ID) => {
    window.intercomSettings = {
        app_id: APP_ID,
        hide_default_launcher: true,
        vertical_padding: 60,
        horizontal_padding: 40,
        showcase: window.appConfig?.showcaseCode,
    };

    (function () {
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === "function") {
            ic('reattach_activator');
            ic('update', w.intercomSettings);
        } else {
            var d = document;
            var i = function () {
                i.c(arguments);
            };
            i.q = [];
            i.c = function (args) {
                i.q.push(args);
            };
            w.Intercom = i;
            var l = function () {
                var s = d.createElement('script');
                s.type = 'text/javascript';
                s.async = true;
                s.src = `https://widget.intercom.io/widget/${APP_ID}`;
                var x = d.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(s, x);
            };
            l();
        }
    })();
};
